module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 3_thumb.6da721f1.jpg";